export const MultipleLinedata = (canvas) => {
  const ctx = canvas.getContext('2d')
  const gradient1 = ctx.createLinearGradient(55, 81, 255, 1)
  gradient1.addColorStop(0, ' blue')
  gradient1.addColorStop(1, '#F5F8FF')
  const data1 = {
    label: 'Current Month',
    data: [5, 20, 40, 20, 38],

    pointRadius: 0,
    borderColor: '#3751FF',
    tension: 0.4,
    fill: false,
    backgroundColor: gradient1,
  }

  const data2 = {
    label: 'Previous month',
    data: [25, 13, 25, 10, 34],

    pointRadius: 0,
    borderColor: '#05CFD3',
    tension: 0.4,
    fill: false,
    backgroundColor: 'rgba(245, 248, 255, 1)',
  }
  return {
    labels: ['', 'Week1', 'Week2', 'Week3', 'Week4'],

    datasets: [data1, data2],
  }
}

export const MultipleLinedataOptions = {
  maintainAspectRatio: false,
  legend: {
    display: true,
    position: 'bottom',
    Align: 'end',
    padding: 20,
    height: '100%',
  },
  scales: {
    xAxes: [
      {
        gridLines: {
          drawOnChartArea: false,
        },
      },
    ],
    yAxes: [
      {
        gridLines: {
          drawOnChartArea: true,
        },
        scaleLabel: {
          display: true,
          labelString: 'No. of Employees',
        },
        ticks: {
          beginAtZero: true,
          minTicksLimit: 6,
          stepSize: 10,
        },
      },
    ],
  },
}

export default { MultipleLinedata, MultipleLinedataOptions }
